import { marker } from '@jsverse/transloco-keys-manager/marker';
import { DialogPlugin } from '@modules/forms/models/dialog-plugin';
import { ModuleId } from '@pixacare/forms';
import { TopocareModuleComponentByModuleId } from '../models/topocare-module-component-by-module-id';
import { TopocareSupportedModuleIds } from '../models/topocare-supported-module-ids';
import { TopocareWrapperComponent } from '../modules/topocare/components/topocare-wrapper.component';

type TopocareModules = {
  [M in TopocareSupportedModuleIds]: DialogPlugin<TopocareModuleComponentByModuleId[M]>;
};

export const topocareModules = {
  [ModuleId.TOPOCARE]: {
    id: ModuleId.TOPOCARE,
    component: TopocareWrapperComponent,
    dependencies: [],
    inputs: {},
    outputs: {
      localization: `localization`,
    },
    config: {
      label: marker('Localiser une lésion'),
      size: 'm',
    },
  },
} satisfies TopocareModules;
